import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { CountryId } from '@as-react/common-types';
const getAddressThirdLineByCountry = (address, country) => {
    if (!address.city && !address.postCode) {
        return null;
    }
    switch (address.country) {
        case 'AU':
        case 'NZ':
            return (_jsxs(_Fragment, { children: [address.city, " ", address.postCode, ", ", country] }));
        case 'GB':
        case 'GG':
        case 'JE':
            return [address.city, address.county, address.postCode, country].filter(Boolean).map((item, index, arr) => (_jsxs(Fragment, { children: [item, index !== arr.length - 1 && _jsx("br", {})] }, item.replace(/ /g, ''))));
        case 'US':
            return (_jsxs(_Fragment, { children: [address.city, ", ", address.county, " ", address.postCode, ", ", country] }));
        default:
            return (_jsxs(_Fragment, { children: [address.postCode, " ", address.city, ", ", country] }));
    }
};
const getAddressStreetInfoByCountry = (address, t) => {
    const houseNumberAddition = address &&
        !!address.houseNumberAddition &&
        `${t(address.idCountry === CountryId.NL ? '' : 'account:delivery.bus')} ${address.houseNumberAddition}`;
    const streetInfoComponents = [
        address.address,
        address.houseNumber,
        address.addressLine2,
        address.addressLine3,
        address.addressLine4,
        houseNumberAddition,
    ].filter(Boolean);
    switch (address.country) {
        case 'GB':
        case 'GG':
        case 'JE':
            return streetInfoComponents.map((street, index, arr) => (_jsxs(Fragment, { children: [street, index !== arr.length - 1 && _jsx("br", {})] }, street.replace(/ /g, ''))));
        default: {
            return streetInfoComponents.join(' ');
        }
    }
};
export const getCustomerAddress = (address, country, t) => {
    const streetInfo = getAddressStreetInfoByCountry(address, t);
    const cityInfo = getAddressThirdLineByCountry(address, country);
    if (streetInfo && cityInfo) {
        return (_jsxs(_Fragment, { children: [streetInfo, _jsx("br", {}), cityInfo] }));
    }
    if (streetInfo) {
        return streetInfo;
    }
    if (cityInfo) {
        return cityInfo;
    }
    return null;
};
